import React, { memo, useMemo } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import Item from './Item';
import { areEqualWithCtx } from './helpers';
import classNames from 'classnames';

function useItemClasses({ isDragging, isOverlay, className }) {
	return classNames([
		className,
		'draggable-item',
		{
			'is-dragging': isDragging,
			'is-overlay': isOverlay,
		},
	]);
}

export const SortableItem = memo(function SortableItem({
	className,
	children,
	ctx,
}) {
	const {
		active,
		attributes,
		isDragging,
		listeners,
		setNodeRef,
		transform,
		transition,
		rect,
	} = useSortable({
		id: ctx.data.id,
		data: ctx,
	});

	const dragRect = rect.current;
	const isTypeSorting =
		transform && active?.data.current?.data.type === ctx.data.type;
	const shouldDisplayDragPlaceholder = isDragging && dragRect;

	const style = useMemo(() => {
		let styles = undefined;

		if (isTypeSorting) {
			styles = {
				transform: CSS.Translate.toString(transform),
				transition: transition || undefined,
			};
		}

		if (shouldDisplayDragPlaceholder) {
			styles = {
				...(styles || {}),
				width: dragRect?.width,
				height: dragRect?.height,
			};
		}

		return styles;
	}, [
		isTypeSorting,
		transform,
		transition,
		shouldDisplayDragPlaceholder,
		dragRect,
	]);

	return (
		<div
			style={style}
			ref={setNodeRef}
			className={useItemClasses({ isDragging, isOverlay: false, className })}
		>
			{shouldDisplayDragPlaceholder
				? null
				: React.cloneElement(children, { listeners })}
		</div>
	);
},
areEqualWithCtx);

export const SortableItemOverlay = memo(function SortableItemOverlay({
	className,
	children,
}) {
	return (
		<div
			className={useItemClasses({
				isDragging: false,
				isOverlay: true,
				className,
			})}
		>
			{children}
		</div>
	);
});
